'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/type.js
// module id = 21
// module chunks = 8